export default "__VITE_ASSET__e0c9057c__"